import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
import ddt from '@wix/da-ddt';
import Modal from '../Popup/Modal';
import ErrorBoundary from '../ErrorBoundary';
import { ModalType } from './redux/types';
import LoadableMediaManager from '../MediaPopup/MediaManager';
import { MediaSourceType } from '../MediaPopup/types';
import { LoadablePostPopup, LoadableWriterPopup, LoadableCommissionEditPopup, LoadablePollEditPopup, LoadableDealerPopup, LoadableAddToCollectionPopoverModal } from './LoadableModals';
import NonContentModals from './NonContentModals';
import LoadableTierPopup from '../Tier/TierPopup';
import LoadableDeviationSubmitPopup from '../DeviationSubmitPopup/LazyDeviationSubmitPopup';
import LoadableNftLinkPopup from '../Nft/NftLinkPopup';
/** Renders a single one of our many modals based on the contents of the `modal` prop */ const DaModal = ({ modal, children, popModal, currentUser, disableAriaHide })=>{
    if (!modal) {
        return null;
    }
    const modalType = modal.type;
    const { options = {} } = modal;
    const { params, wrapInModal = true, closeBtnClassName } = options;
    let content;
    if (children) {
        try {
            const renderedChildren = children(modalType, popModal, params);
            content = renderedChildren && /*#__PURE__*/ React.createElement(ErrorBoundary, {
                debugComponent: "DaModal"
            }, renderedChildren);
        } catch (e) {
            ddt.error('modals', 'Failed to render custom render function', e);
        }
    }
    if (!content) {
        switch(modalType){
            case ModalType.STATUS_UPDATE:
                return /*#__PURE__*/ React.createElement(LoadablePostPopup, _object_spread_props(_object_spread({
                    onClose: popModal
                }, params), {
                    mode: "status"
                }));
            case ModalType.JOURNAL:
                return /*#__PURE__*/ React.createElement(LoadablePostPopup, _object_spread_props(_object_spread({
                    onClose: popModal
                }, params), {
                    mode: "journal"
                }));
            case ModalType.LITERATURE:
                return /*#__PURE__*/ React.createElement(LoadableWriterPopup, _object_spread_props(_object_spread({
                    onClose: popModal
                }, params), {
                    type: "LITERATURE"
                }));
            case ModalType.CREATE_PREMIUM_FOLDER:
                const reloadPage = (event)=>{
                    popModal();
                    event && event.preventDefault();
                    window.location.reload();
                };
                return /*#__PURE__*/ React.createElement(LoadableMediaManager, {
                    initialMediaSource: MediaSourceType.GALLERY,
                    withMediaSourceSelector: false,
                    withNewGallectionPopupOpen: true,
                    onDone: reloadPage,
                    onClose: reloadPage
                });
            case ModalType.COMMISSION:
                return /*#__PURE__*/ React.createElement(LoadableCommissionEditPopup, _object_spread({
                    onClose: popModal
                }, params));
            case ModalType.POLL_EDIT:
                return /*#__PURE__*/ React.createElement(LoadablePollEditPopup, params);
            case ModalType.TIER_EDIT:
                return /*#__PURE__*/ React.createElement(LoadableTierPopup, _object_spread({
                    requestClose: popModal
                }, params));
            case ModalType.DEVIATION_SUBMIT:
                return /*#__PURE__*/ React.createElement(LoadableDeviationSubmitPopup, _object_spread({
                    requestClose: popModal
                }, params));
            case ModalType.NFT_LINK:
                return /*#__PURE__*/ React.createElement(LoadableNftLinkPopup, _object_spread({
                    requestClose: popModal
                }, params));
            case ModalType.COLLECTION_POPOVER:
                return /*#__PURE__*/ React.createElement(LoadableAddToCollectionPopoverModal, params);
            case ModalType.DEALER:
                return /*#__PURE__*/ React.createElement(LoadableDealerPopup, params);
            default:
                content = /*#__PURE__*/ React.createElement(NonContentModals, {
                    modalType,
                    popModal,
                    params,
                    currentUser
                });
        }
    }
    return content && wrapInModal ? /*#__PURE__*/ React.createElement(Modal, {
        onRequestClose: popModal,
        withCloseButton: true,
        isOpen: true,
        width: "auto",
        height: "auto",
        disableAriaHide: disableAriaHide,
        closeBtnClassName: closeBtnClassName
    }, content) : content;
};
DaModal.displayName = 'DaModal';
export default DaModal;
